declare const Routing: any;

interface SvodCheckResponse {
    isUserFilmSvodAllowed: boolean;
}

interface OpenPlayerStatus extends Boolean {}

interface LmcPlayer {
    downloadPlayer(): Promise<void>;
    openPlayer(authToken?: string, productUuid?: string): Promise<OpenPlayerStatus>;
}

declare const initApp: () => void;

// @ts-ignore
declare global {
    interface Window {
        lmcPlayer: LmcPlayer;
        downloadLatestVersion: () => void;
        openInstallPlayer: (anchor: HTMLElement) => void;
        openPlayer: () => void;
        openPlayerWithAuth: (authToken: string) => void;
        openPlayerWithDl: (
            authToken: string,
            videoId: string,
            url: string,
            availId: string
        ) => void;
    }
}

// --------------------------------------
// Helper to Open Bootstrap Modal
// --------------------------------------
function openModal(id: string): void {
    const el = document.getElementById(id);
    if (!el) return;

    el.style.display = "block";
}

// --------------------------------------
// downloadLatestVersion
// --------------------------------------
// @ts-ignore
window.downloadLatestVersion = function (): void {
    // @ts-ignore
    window.lmcPlayer
        .downloadPlayer()
        .then(() => {})
        .catch((error: any) => console.error(error));
};


// --------------------------------------
// openInstallPlayer
// --------------------------------------
// @ts-ignore
window.openInstallPlayer = function (anchor: HTMLElement): void {
    const filmId = anchor.dataset.svod_film_id;

    if (filmId) {
        fetch(
            Routing.generate("uc_fo_svod_check_film", { filmId }),
            { headers: { Accept: "application/json" } }
        )
            .then((res) => res.json() as Promise<SvodCheckResponse>)
            .then((response) => {
                if (response.isUserFilmSvodAllowed) {
                    openModal("splashDownloadModal1");
                } else {
                    alert(
                        "Une erreur s'est produite, merci d'essayer de nouveau ou contacter l'assistance."
                    );
                }
            })
            .catch((err) => console.error(err));
    } else {
        openModal("splashDownloadModal1");
    }
};


// --------------------------------------
// openPlayer
// --------------------------------------
// @ts-ignore
window.openPlayer = function (): void {
    const loader = document.querySelector(".loading-centered");
    if (!loader) return;

    loader.classList.remove("hidden");

    // @ts-ignore
    window.lmcPlayer
        .openPlayer()
        .then((status: any) => {
            loader.classList.add("hidden");
            console.log("player open status:", status);

            if (status === false) {
                console.log("Veuillez installer le player");
                openModal("splashDownloadModal1");
            }
        })
        .catch((error: any) => console.error(error));
};


// --------------------------------------
// openPlayerWithAuth
// --------------------------------------
// @ts-ignore
window.openPlayerWithAuth = function (authToken: string): void {
    const loader = document.querySelector(".loading-centered");
    if (!loader) return;

    loader.classList.remove("hidden");

    // @ts-ignore
    window.lmcPlayer
        .openPlayer(authToken)
        .then((status: any) => {
            loader.classList.add("hidden");
            console.log("player open status:", status);

            if (status === false) {
                console.log("Veuillez installer le player");
                openModal("splashDownloadModal1");
            }
        })
        .catch((error: any) => console.error(error));
};


// --------------------------------------
// openPlayerWithDl
// --------------------------------------
// @ts-ignore
window.openPlayerWithDl = function (
    authToken: string,
    videoId: string,
    url: string,
    availId: string
): void {
    const loader = document.querySelector(".loading-centered");
    if (!loader) return;

    loader.classList.remove("hidden");

    const formData = new URLSearchParams({
        productUuid: videoId,
        availId: availId,
    });

    fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: formData,
    })
        .then((res) => {
            if (!res.ok) throw new Error();
            return res.json() as Promise<{ productUuid: string }>;
        })
        .then((response) => {
            // @ts-ignore
            return window.lmcPlayer.openPlayer(authToken, response.productUuid);
        })
        .catch(() => {
            // @ts-ignore
            return window.lmcPlayer.openPlayer(authToken, videoId);
        })
        .then((status) => {
            loader.classList.add("hidden");
            console.log("player open status:", status);

            if (status === false) {
                console.log("Veuillez installer le player");
                openModal("splashDownloadModal1");
            }
        })
        .catch((error) => console.error(error));
};

// --------------------------------------
// On DOM ready
// --------------------------------------
document.addEventListener("DOMContentLoaded", initApp);
